import { REVALIDATION_TAGS } from '@core/constants/revalidationTags.constants';
import { RouteTags } from '@core/types/routeTags.types';

const COMMON_TAGS = {
  BASE: [
    REVALIDATION_TAGS.SITE_SETTINGS,
    REVALIDATION_TAGS.DICTIONARY_KEY,
    REVALIDATION_TAGS.NAVIGATION,
    REVALIDATION_TAGS.ITEM_NAVIGATION,
    REVALIDATION_TAGS.GLOBAL_SETTINGS,
    REVALIDATION_TAGS.FOOTER_BLOCK,
  ],
  FIXTURE_PATH: [
    REVALIDATION_TAGS.FIXTURE_LISTING_PAGE,
    REVALIDATION_TAGS.CONTENT_PAGE,
    REVALIDATION_TAGS.ARTICLE_PAGE,
    REVALIDATION_TAGS.HOME_PAGE,
  ],
  FIXTURE_CONTENT: [
    REVALIDATION_TAGS.TEAM,
    REVALIDATION_TAGS.FIXTURE,
    REVALIDATION_TAGS.SEASON,
    REVALIDATION_TAGS.COMPETITION,
    REVALIDATION_TAGS.CLUB,
    REVALIDATION_TAGS.PROFILE,
  ],
} as const;

export const tags: Partial<RouteTags> = {
  CONTENT: {
    pathTags: [REVALIDATION_TAGS.CONTENT_PAGE],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.HEADER_BLOCK,
      REVALIDATION_TAGS.HEADER_HERO_BLOCK,
      REVALIDATION_TAGS.CONTENT_SCROLLER_BLOCK,
      REVALIDATION_TAGS.DOWNLOAD_BLOCK,
      REVALIDATION_TAGS.GATEWAY_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.PROMO_BLOCK,
      REVALIDATION_TAGS.STATS_BLOCK,
      REVALIDATION_TAGS.TEXT_BLOCK,
      REVALIDATION_TAGS.TEXT_WITH_IMAGE_BLOCK,
      REVALIDATION_TAGS.ACCORDION_BLOCK,
      REVALIDATION_TAGS.ACCORDION_SECTION,
      REVALIDATION_TAGS.EMBED_BLOCK,
      REVALIDATION_TAGS.NEWS_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.PROMO_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.ARTICLE_PROMO_BLOCK,
      REVALIDATION_TAGS.TABBED_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.TABLE_BLOCK,
      REVALIDATION_TAGS.PULL_QUOTE_EMBED,
      REVALIDATION_TAGS.HERO_SLIDE,
      REVALIDATION_TAGS.FIXTURES_SUMMARY_BLOCK,
      REVALIDATION_TAGS.SCRIPT_EMBED,
      REVALIDATION_TAGS.AD_SLOT,
      REVALIDATION_TAGS.THEME,
    ],
  },
  ARTICLE: {
    pathTags: [
      REVALIDATION_TAGS.NEWS_LISTING_PAGE,
      REVALIDATION_TAGS.ARTICLE_PAGE,
      REVALIDATION_TAGS.GALLERY_ARTICLE_PAGE,
      REVALIDATION_TAGS.VIDEO_ARTICLE_PAGE,
    ],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.NEWS_CATEGORY,
      REVALIDATION_TAGS.NEWS_TAG,
      REVALIDATION_TAGS.NEWS_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.TEXT_BLOCK,
      REVALIDATION_TAGS.TEXT_WITH_IMAGE_BLOCK,
      REVALIDATION_TAGS.DOWNLOAD_BLOCK,
      REVALIDATION_TAGS.ACCORDION_BLOCK,
      REVALIDATION_TAGS.STATS_BLOCK,
      REVALIDATION_TAGS.PROMO_BLOCK,
      REVALIDATION_TAGS.GALLERY,
      REVALIDATION_TAGS.SCRIPT_EMBED,
      REVALIDATION_TAGS.AD_SLOT,
      REVALIDATION_TAGS.THEME,
      REVALIDATION_TAGS.CATEGORY,
      REVALIDATION_TAGS.TEAM,
      REVALIDATION_TAGS.SOCIAL_EMBED,
    ],
  },
  HOME: {
    pathTags: [REVALIDATION_TAGS.HOME_PAGE],
    contentTags: [
      ...COMMON_TAGS.BASE,
      ...COMMON_TAGS.FIXTURE_CONTENT,
      REVALIDATION_TAGS.HEADER_BLOCK,
      REVALIDATION_TAGS.HEADER_HERO_BLOCK,
      REVALIDATION_TAGS.CONTENT_SCROLLER_BLOCK,
      REVALIDATION_TAGS.DOWNLOAD_BLOCK,
      REVALIDATION_TAGS.GATEWAY_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.PROMO_BLOCK,
      REVALIDATION_TAGS.STATS_BLOCK,
      REVALIDATION_TAGS.TEXT_BLOCK,
      REVALIDATION_TAGS.TEXT_WITH_IMAGE_BLOCK,
      REVALIDATION_TAGS.ACCORDION_BLOCK,
      REVALIDATION_TAGS.ACCORDION_SECTION,
      REVALIDATION_TAGS.EMBED_BLOCK,
      REVALIDATION_TAGS.NEWS_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.PROMO_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.ARTICLE_PROMO_BLOCK,
      REVALIDATION_TAGS.TABBED_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.TABLE_BLOCK,
      REVALIDATION_TAGS.PULL_QUOTE_EMBED,
      REVALIDATION_TAGS.HERO_SLIDE,
      REVALIDATION_TAGS.FIXTURES_SUMMARY_BLOCK,
    ],
  },
  FIXTURES: {
    pathTags: [...COMMON_TAGS.FIXTURE_PATH],
    contentTags: [...COMMON_TAGS.BASE, ...COMMON_TAGS.FIXTURE_CONTENT],
  },
  FIXTURES_COMPETITION: {
    pathTags: [...COMMON_TAGS.FIXTURE_PATH],
    contentTags: [...COMMON_TAGS.BASE, ...COMMON_TAGS.FIXTURE_CONTENT],
  },
  RESULTS: {
    pathTags: [...COMMON_TAGS.FIXTURE_PATH],
    contentTags: [...COMMON_TAGS.BASE, ...COMMON_TAGS.FIXTURE_CONTENT],
  },
  RESULTS_COMPETITION: {
    pathTags: [...COMMON_TAGS.FIXTURE_PATH],
    contentTags: [...COMMON_TAGS.BASE, ...COMMON_TAGS.FIXTURE_CONTENT],
  },
  RESULTS_COMPETITION_SEASON: {
    pathTags: [...COMMON_TAGS.FIXTURE_PATH],
    contentTags: [...COMMON_TAGS.BASE, ...COMMON_TAGS.FIXTURE_CONTENT],
  },
  TABLE: {
    pathTags: [REVALIDATION_TAGS.FIXTURE_LISTING_PAGE],
    contentTags: [REVALIDATION_TAGS.DICTIONARY_KEY],
  },
  TABLE_COMPETITION: {
    pathTags: [REVALIDATION_TAGS.FIXTURE_LISTING_PAGE],
    contentTags: [REVALIDATION_TAGS.DICTIONARY_KEY],
  },
  TABLE_COMPETITION_SEASON: {
    pathTags: [REVALIDATION_TAGS.FIXTURE_LISTING_PAGE],
    contentTags: [REVALIDATION_TAGS.DICTIONARY_KEY],
  },
  MATCH_CENTRE: {
    pathTags: [REVALIDATION_TAGS.FIXTURE_LISTING_PAGE],
    contentTags: [...COMMON_TAGS.BASE, ...COMMON_TAGS.FIXTURE_CONTENT],
  },
  NEWS_CATEGORY: {
    pathTags: [
      REVALIDATION_TAGS.CONTENT_PAGE,
      REVALIDATION_TAGS.ARTICLE_PAGE,
      REVALIDATION_TAGS.NEWS_LISTING_PAGE,
    ],
    contentTags: [
      REVALIDATION_TAGS.NEWS_TAG,
      REVALIDATION_TAGS.NEWS_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.DICTIONARY_KEY,
    ],
  },
  NEWS_TAG: {
    pathTags: [
      REVALIDATION_TAGS.CONTENT_PAGE,
      REVALIDATION_TAGS.ARTICLE_PAGE,
      REVALIDATION_TAGS.NEWS_LISTING_PAGE,
    ],
    contentTags: [
      REVALIDATION_TAGS.NEWS_TAG,
      REVALIDATION_TAGS.NEWS_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.DICTIONARY_KEY,
    ],
  },
  NEWS_LISTING: {
    pathTags: [
      REVALIDATION_TAGS.ARTICLE_PAGE,
      REVALIDATION_TAGS.NEWS_LISTING_PAGE,
    ],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.PROMO_BLOCK,
      REVALIDATION_TAGS.GATEWAY_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.IN_PAGE_HEADER_NAVIGATION,
      REVALIDATION_TAGS.NEWS_CAROUSEL_BLOCK,
    ],
  },
  NEWS_LISTING_BY_SLUG: {
    pathTags: [
      REVALIDATION_TAGS.ARTICLE_PAGE,
      REVALIDATION_TAGS.NEWS_LISTING_PAGE,
    ],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.PROMO_BLOCK,
      REVALIDATION_TAGS.GATEWAY_CAROUSEL_BLOCK,
      REVALIDATION_TAGS.IN_PAGE_HEADER_NAVIGATION,
      REVALIDATION_TAGS.NEWS_CAROUSEL_BLOCK,
    ],
  },
  PROFILE: {
    pathTags: [REVALIDATION_TAGS.PROFILE_PAGE],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.PROFILE,
      REVALIDATION_TAGS.TEAM,
    ],
  },
  TEAM: {
    pathTags: [REVALIDATION_TAGS.TEAM_PAGE],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.TEAM,
      REVALIDATION_TAGS.PROFILE,
    ],
  },
  VIDEO_DETAIL: {
    pathTags: [REVALIDATION_TAGS.ARTICLE_PAGE, REVALIDATION_TAGS.FIXTURE],
    contentTags: [...COMMON_TAGS.BASE, REVALIDATION_TAGS.VIDEO],
  },
  VIDEO_LANDING: {
    pathTags: [REVALIDATION_TAGS.VIDEO_LANDING_PAGE],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.VIDEO_CAROUSEL,
      REVALIDATION_TAGS.HERO_SLIDE,
      REVALIDATION_TAGS.VIDEO,
    ],
  },
  VIDEO_PLAYLIST_LISTING: {
    pathTags: [REVALIDATION_TAGS.VIDEO_LANDING_PAGE],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.VIDEO_CAROUSEL,
      REVALIDATION_TAGS.HERO_SLIDE,
      REVALIDATION_TAGS.VIDEO,
    ],
  },
  VIDEO_PLAYLIST: {
    pathTags: [REVALIDATION_TAGS.VIDEO_LANDING_PAGE],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.VIDEO,
      REVALIDATION_TAGS.VIDEO_CAROUSEL,
    ],
  },
  VIDEO_CATEGORY: {
    pathTags: [REVALIDATION_TAGS.VIDEO_LANDING_PAGE],
    contentTags: [
      ...COMMON_TAGS.BASE,
      REVALIDATION_TAGS.VIDEO,
      REVALIDATION_TAGS.VIDEO_CAROUSEL,
      REVALIDATION_TAGS.HERO_SLIDE,
    ],
  },
};
